import { useEffect } from "react";

interface Props {
  ref: React.RefObject<HTMLElement>;
  setShowModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useOutsideCloseModal = ({ ref, setShowModal }: Props): void => {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent): void {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setShowModal && setShowModal(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setShowModal]);
};
